import React, { Component } from "react";
import $ from "jquery";
import { message, Dropdown, Menu, Modal, Switch } from "antd";
import Bridge from "../utils/Bridge";
import { RESEARCH_TYPE } from "../utils/consts";
import { translateApiMessage } from "../utils/functions";

import englishJson from "../utils/language/leStudy/english.json";
import spanishJson from "../utils/language/leStudy/spanish.json";

import { connect } from "react-redux";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalVisible: false,
      toggleStatus: false,
      readInSpanish: false,
      language: props.language || "English",
    };
  }
  componentDidMount() {
    if (
      RESEARCH_TYPE != "modality.ai" &&
      RESEARCH_TYPE != "ECAS Study" &&
      RESEARCH_TYPE != "LE Study" &&
      window.location.pathname == "/create-new-account"
    ) {
      window.location.assign("/");
      return;
    }
    if (RESEARCH_TYPE == "LE Study") {
      if (localStorage.getItem("ap_language") == "Spanish only") {
        this.setState({ readInSpanish: true });
      }
    }
    // adding check for inner logged in screens
    if (
      window.location.pathname != "/" &&
      window.location.pathname != "/forgot-password" &&
      window.location.pathname != "/create-new-account"
    ) {
      if (!localStorage.getItem("ap_id")) {
        localStorage.clear();
        message.success("Please try to login.");
        window.location.assign("/");
      }
    }
    // check for modality.ai user if account selected or not
    if (RESEARCH_TYPE == "modality.ai") {
      if (
        !localStorage.getItem("ap_participants_accounts_id") &&
        window.location.pathname != "/select-user-account" &&
        window.location.pathname != "/" &&
        window.location.pathname != "/forgot-password" &&
        window.location.pathname != "/create-new-account"
      ) {
        window.location.assign("/select-user-account");
        return;
      }
    }
    $("#mobile-menu").slideUp();
    this.checkConsentFormStatus();
    this.check_for_user_page_validations();
  }
  check_for_user_page_validations() {
    if (RESEARCH_TYPE == "Asymptomatic Study") {
      if (window.location.pathname == "/add-physical-ecas-form") {
        window.location.assign("/dashboard");
      }
    } else if (RESEARCH_TYPE == "ECAS Study") {
      if (window.location.pathname == "/upload-pdf-for-genetic-confirmation") {
        window.location.assign("/dashboard");
      }
    } else if (RESEARCH_TYPE == "LE Study") {
      if (window.location.pathname == "/upload-pdf-for-genetic-confirmation") {
        window.location.assign("/dashboard");
      }
    }
  }
  checkConsentFormStatus = () => {
    if (localStorage.getItem("aptoken")) {
      if (RESEARCH_TYPE == "modality.ai") {
        let parameter =
          "?participants_accounts_id=" +
          localStorage.getItem("ap_participants_accounts_id");
        Bridge.consent_form.speech
          .check_consent_form_status(parameter)
          .then((response) => {
            this.setState({ loading: false });
            if (response.status == "1") {
              if (response.data == false) {
                if (window.location.pathname != "/consent-form") {
                  window.location.assign("/consent-form");
                }
              }
            }
          })
          .catch((error) => {
            this.setState({ loading: false });
          });
      } else {
        let params =
          "?eals_id=" +
          localStorage.getItem("ap_eals_id") +
          "&research_type=" +
          RESEARCH_TYPE;
        Bridge.consent_form.get(params).then((response) => {
          if (response.status == 1) {
            if (response.data == false) {
              if (window.location.pathname != "/consent-form") {
                window.location.assign("/consent-form");
              }
            }
          }
        });
      }
    }
  };
  toggleMenu = () => {
    let status = !this.state.toggleStatus;
    this.setState({
      toggleStatus: status,
    });
    if (status == true) {
      $("#mobile-menu").slideUp();
    } else {
      $("#mobile-menu").slideDown();
    }
  };
  // show modal
  showModal = () => {
    this.setState({
      modalVisible: true,
    });
  };
  // close modal to logout
  logout = () => {
    const currentLanguage =
      this.props.selectedLanguage || this.props.language || this.state.language || "English";
    const formData =
      RESEARCH_TYPE == "LE Study"
        ? currentLanguage == "English"
          ? englishJson
          : spanishJson
        : englishJson;
    message.success(translateApiMessage("Logged Out Successfully", currentLanguage));
    localStorage.clear();
    localStorage.clear();
    this.setState({ modalVisible: false }, () => {
      setTimeout(() => {
        window.location.assign("/");
      }, 2000);
    });
  };
  // hide modal
  closeModal = () => {
    this.setState({
      modalVisible: false,
    });
  };
  render() {
    // Use selectedLanguage prop if passed directly (from Signin), otherwise use Redux language state
    const currentLanguage =
      this.props.selectedLanguage || this.props.language || "English";
    const formData =
      RESEARCH_TYPE == "LE Study"
        ? currentLanguage == "English"
          ? englishJson
          : spanishJson
        : englishJson;
    const LoggedInUserMenu = (
      <Menu>
        <Menu.Item>
          <a href="/change-password">
            <i className="fas fa-key"></i> {formData.page.header.changePassword}
          </a>
        </Menu.Item>
        {RESEARCH_TYPE == "modality.ai" &&
        localStorage.getItem("ap_participants_accounts_id") &&
        localStorage.getItem("is_multiple_accounts_present") == "true" ? (
          <Menu.Item>
            <a href="/select-user-account">
              <i className="fas fa-user"></i> Switch Account
            </a>
          </Menu.Item>
        ) : (
          ""
        )}
        <Menu.Item>
          <a
            href="#"
            rel="noopener noreferrer"
            onClick={() => this.showModal()}
          >
            <i className="fas fa-sign-out-alt"></i>{" "}
            {formData.page.header.signOut}
          </a>
        </Menu.Item>
      </Menu>
    );
    const GuestMenu = (
      <Menu>
        <Menu.Item>
          <a href="/">
            <i className="fas fa-sign-out-alt"></i> {formData.page.header.login}
          </a>
        </Menu.Item>
      </Menu>
    );
    return (
      <header className="">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-section">
                {localStorage.getItem("ap_id") ? (
                  <a href="/dashboard">
                    <div className="left-side">
                      <img
                        src={"./assets/images/header-logo.png"}
                        className="header-logo"
                      />
                      <h2>{formData.page.header.title}</h2>
                    </div>
                  </a>
                ) : (
                  <div className="left-side">
                    <img
                      src={"./assets/images/header-logo.png"}
                      className="header-logo"
                    />
                    <h2>{formData.page.header.title}</h2>
                  </div>
                )}

                {localStorage.getItem("ap_id") ? (
                  <div className="d-flex">
                    <Dropdown overlay={LoggedInUserMenu}>
                      <a
                        href="#!"
                        className="d-none d-sm-none d-md-block d-lg-block d-xl-block"
                        style={{
                          position: "relative",
                          top: -4,
                        }}
                      >
                        <box-icon
                          type="solid"
                          name="user"
                          color="#fff"
                          style={{
                            position: "relative",
                            top: 7,
                          }}
                        ></box-icon>{" "}
                        &nbsp;
                        {localStorage.getItem("ap_name")}
                        <box-icon
                          type="solid"
                          name="down-arrow"
                          color="#fff"
                          size={"16px"}
                          style={{
                            position: "relative",
                            top: 3,
                            left: 5,
                          }}
                        ></box-icon>
                      </a>
                    </Dropdown>
                  </div>
                ) : (
                  ""
                )}
                {localStorage.getItem("ap_id") ? (
                  <Dropdown overlay={LoggedInUserMenu}>
                    <div
                      id="menu-icon"
                      className="menu-icon d-block d-sm-block d-md-none d-lg-none d-xl-none"
                    >
                      <box-icon
                        name="menu"
                        color="#fff"
                        size={"30px"}
                      ></box-icon>
                    </div>
                  </Dropdown>
                ) : (
                  <>
                    {window.location.pathname != "/" && (
                      <Dropdown overlay={GuestMenu}>
                        <div
                          id="menu-icon"
                          className="menu-icon d-block d-sm-block d-md-none d-lg-none d-xl-none"
                        >
                          <box-icon
                            name="menu"
                            color="#fff"
                            size={"30px"}
                          ></box-icon>
                        </div>
                      </Dropdown>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <Modal
          title={formData.page.header.confirm}
          visible={this.state.modalVisible}
          onOk={this.logout}
          onCancel={this.closeModal}
          okText={formData.page.header.yes}
          cancelText={formData.page.header.no}
          style={{ maxWidth: window.innerWidth < 600 ? "100%" : 480 }}
        >
          <h6 className="pt-4 pb-2">
            {formData.page.header.areYouSureYouWantToSignOut}
          </h6>
        </Modal>
      </header>
    );
  }
}

// Map Redux state to component props
const mapStateToProps = (state) => ({
  language: state.language.language,
});

// Connect the component to Redux store
export default connect(mapStateToProps)(Header);
